import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Switch as MuiSwitch, Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const Switch = props => {
  const { className, showLabel, checked, ...rest } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const label = checked ? t('components.Switch.on') : t('components.Switch.off');

  return (
    <Box className={classes.container}>
      {showLabel && (
        <Typography variant="body1" className={clsx({ [classes.textRight]: !checked, [classes.textLeft]: checked })}>
          {label}
        </Typography>
      )}
      <MuiSwitch className={clsx(classes.root, className)} checked={checked} {...rest} />
    </Box>
  );
};

Switch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  showLabel: PropTypes.bool,
};

Switch.defaultProps = {
  className: '',
  showLabel: false,
};

export default Switch;



// WEBPACK FOOTER //
// ./src/sharedComponents/Switch/Switch.js